import api from './clients';

export interface Usuario {
  id: number;
  usuario: string;
  nombre: string | null;
  descripcion: string | null;
  email: string | null;
  role: string;
  rolId: number | null;
  rol?: {
    id: number;
    nombre: string;
  } | null;
  activo: boolean;
  createdAt: string;
  updatedAt: string;
}

export const usuariosApi = {
  getAll: async (): Promise<Usuario[]> => {
    const response = await api.get('/usuarios');
    return response.data?.data || [];
  },

  getById: async (id: number): Promise<Usuario> => {
    const response = await api.get(`/usuarios/${id}`);
    return response.data?.data;
  },

  create: async (data: Partial<Usuario> & { contrasena: string }): Promise<Usuario> => {
    const response = await api.post('/usuarios', data);
    return response.data?.data;
  },

  update: async (id: number, data: Partial<Usuario> & { contrasena?: string }): Promise<Usuario> => {
    const response = await api.put(`/usuarios/${id}`, data);
    return response.data?.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/usuarios/${id}`);
  },
};